var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publish-works"},[_vm._v("发布作品")])
}
var staticRenderFns = []

export { render, staticRenderFns }